<template lang='pug' src='./home.pug'></template>

<script>
import HeroHome from 'components/hero/hero-home/hero-home'
import HomeHeader from 'components/custom/custom-home-header/custom-home-header'
// import HomeVideo from 'components/custom/custom-home-video/custom-home-video'
import HomeIcons from 'components/custom/custom-home-icons/custom-home-icons'
import HomeLogobar from 'components/custom/custom-home-logobar/custom-home-logobar'
import HomeMeetDoc from 'components/custom/custom-home-meet-doc/custom-home-meet-doc'
import HomeSections from 'components/custom/custom-home-sections/custom-home-sections'
import Loader from 'components/loader/loader'
import SliderOurSmiles from 'components/slider/slider-our-smiles/slider-our-smiles'
import SliderTestimonials from 'components/slider/slider-testimonials/slider-testimonials'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    HeroHome,
    HomeHeader,
    // HomeVideo,
    HomeIcons,
    HomeLogobar,
    HomeMeetDoc,
    HomeSections,
    Loader,
    SliderOurSmiles,
    SliderTestimonials
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?0cec4dc9